export const setBetStatusFilter = (betStatus) => {
  return {
    type: "SET_BET_STATUS_FILTER",
    betStatus,
  };
};
